import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { z } from 'zod';
import {
  ToggleButtonGroup,
  ToggleButtonGroupOption,
} from '../../../components/toggle-button-group/ToggleButtonGroup';
import { getParsedValueOr } from '../../../utilities/Zod';
import { Label, Root } from './SearchTypeSelectorStyle';

interface SearchTypeSelectorProps {
  /** @default false */
  mobile?: boolean;
}

export const searchTypeParam = 'search-type';
export const defaultSearchType: SearchType = 'materialType.name';

export function SearchTypeSelector(props: SearchTypeSelectorProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = useMemo(
    () => getParsedValueOr(searchTypeSchema, searchParams.get(searchTypeParam), defaultSearchType),
    [searchParams]
  );

  const mobile = props.mobile ?? false;
  return (
    <Root $mobile={mobile}>
      <Label>Recherche par</Label>
      <ToggleButtonGroup
        mobile={mobile}
        options={
          [
            {
              label: 'Type',
              value: 'materialType.name',
            },
            {
              label: 'Immatriculation / Identification',
              value: 'matriculation',
            },
          ] as ToggleButtonGroupOption<SearchType>[]
        }
        value={value}
        onValueChange={(newValue) => {
          const newParams = new URLSearchParams(searchParams);
          newParams.set(searchTypeParam, newValue);
          setSearchParams(newParams);
        }}
      />
    </Root>
  );
}

export const searchTypeSchema = z.union([z.literal('materialType.name'), z.literal('matriculation')]);
export type SearchType = z.infer<typeof searchTypeSchema>;
